import { Role, type TextMessage } from "@copilotkit/runtime-client-gql";
import Box from "@memorang/ui/components/Box";
import MarkdownRenderer from "@memorang/ui/components/MarkdownRenderer";
import { useAppTheme } from "@memorang/ui/useAppTheme";
import { Text } from "react-native-paper";

export const MessageContainer = ({
	message,
}: {
	message: TextMessage;
}) => {
	const theme = useAppTheme();

	const alignment = message.role === Role.Assistant ? "flex-start" : "flex-end";
	const color =
		message.role === Role.Assistant
			? theme.colors.onSurfaceVariant
			: theme.colors.onPrimary;
	const bgColor =
		message.role === Role.Assistant
			? theme.colors.surfaceVariant
			: theme.colors.primary;

	return (
		<Box flexDirection="row" justifyContent={alignment}>
			<Box
				maxWidth="80%"
				backgroundColor={bgColor}
				padding={16}
				borderRadius={theme.roundness}
			>
				<MarkdownRenderer
					text={message.content}
					fontSize={16}
					customStyles={{
						text: {
							lineHeight: 24,
							color,
						},
						code_inline: {
							borderRadius: 4,
							textWrap: "nowrap",
							padding: 4,
						},
					}}
					overrideRules={{
						// biome-ignore lint/suspicious/noExplicitAny: Valid use case
						strong: (node: any, children: any) => (
							<Text key={node.key} variant="titleMedium">
								{children}
							</Text>
						),
					}}
				/>
			</Box>
		</Box>
	);
};
